'use client';

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import join from 'url-join';
import { getCWEA, getENV } from '../../utils';
import { CopilotKit, useChatThread } from '../runtime';
import { chatHeaders } from '../utils';
export function ChatbotProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    threadId
  } = useChatThread();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = join(getCWEA(), "chat/runtime");
    t2 = getENV("NEXT_PUBLIC_COPILOTKIT_DEVTOOLS");
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== threadId) {
    t3 = <CopilotKit headers={chatHeaders} runtimeUrl={t1} enableInspector={t2} useSingleEndpoint={false} threadId={threadId}>{children}</CopilotKit>;
    $[2] = children;
    $[3] = threadId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}